import Vue from 'vue'
import Router from 'vue-router'
import * as tokenAPI from '@/js/tokenProcess'
// import ApiGateway from '@/components/overview/tabs/ApiGateway'

Vue.use(Router)
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

// export default new Router({
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/msf/agent',
      component: resolve => require(['@/components/Navigator'], resolve),
      children: [
        {
          path: '/msf/agent',
          name: 'msfAgent',
          component: resolve => require(['@/components/License'], resolve),
        },
      ],

    },
  ]
})

function routeInterupter(to, from, next) {
  console.log(`routeInterupter to:${to.name} from:${from.name} next:${next.name}`)
  let EIToken = tokenAPI.getCookie('EIToken')
  next()
}

router.beforeEach((to, from, next) => {
  routeInterupter(to, from, next)
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js